import { useRef, useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

interface LottieElementProps {
  src: string;
  className?: string;
  scroller: string;
  onReady?: () => void;
}

const LottieElement = ({ src, className, scroller, onReady }: LottieElementProps) => {
  const lottieRef = useRef<HTMLImageElement>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const lottieElement = lottieRef.current
    if (lottieElement) {
      const handleLoad = () => {
        console.log('Lottie fully loaded via custom event!');
        setLoaded(true);
        onReady?.();
      };

      // Regular 'onLoad' attribute wont work with custom components like <lottie-player>. 
      // Hence, we manually attach a load event listener here...
      lottieRef.current.addEventListener('load', handleLoad);

      return () => {
        lottieElement.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  useGSAP(() => {
    if (!loaded || !lottieRef.current) return;

    gsap.fromTo(
      lottieRef.current,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: lottieRef.current,
          start: 'top 95%',
          // markers: true,
          scroller: scroller,
        },
      }
    );
  }, [loaded]);

  return (
    <div className={className}>
      <lottie-player
        ref={lottieRef}
        autoplay
        loop
        mode="normal"
        src={src}
      />
    </div>
  );
};

export default LottieElement;
